import React, { useState, useEffect, useContext } from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import Board from "react-trello";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import { useHistory } from "react-router-dom";
import Title from "../../components/Title";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  button: {
    background: "#10a110",
    border: "none",
    padding: "10px",
    color: "white",
    fontWeight: "bold",
    borderRadius: "5px",
  },
}));

const Kanban = () => {
  const classes = useStyles();
  const history = useHistory();

  const [tags, setTags] = useState([]);

  const fetchTags = async () => {
    try {
      const response = await api.get("/tags/kanban");
      const fetchedTags = response.data.lista ?? [];

      setTags(fetchedTags);

      // Fetch tickets after fetching tags
      await fetchTickets(jsonString);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const [file, setFile] = useState({
    lanes: [],
  });

  const { user } = useContext(AuthContext);
  const { profile, queues } = user;
  const [tickets, setTickets] = useState([]);
  const [queue, setQueue] = useState(profile === "admin" ? 0 : (user.queues && user.queues[0] ? user.queues[0].id : null));
  const jsonString = queues.map((queue) => queue.UserQueue.queueId);

  const fetchTickets = async (jsonString) => {
    try {
      const { data } = await api.get("/ticket/kanban", {
        params: {
          queueIds: JSON.stringify(jsonString),
          showAll: profile === "admin",
        },
      });

      setTickets(data.tickets);
    } catch (err) {
      console.log(err);
      setTickets([]);
    }
  };

  const popularCards = (jsonString) => {
    const filteredTickets = tickets.filter(
      (ticket) => ticket.tags.length === 0
    );


    const lanes = [
      {
        id: "lane0",
        title: i18n.t("kanban.open"),
        label: filteredTickets.length.toString(),
        cards: filteredTickets.map((ticket) => ({
          id: ticket.id.toString(),
          label: "Ticket nº " + ticket.id.toString(),
          description: (
            <div>
              <p>
                {ticket.contact.number}
                <br />
                {ticket.lastMessage}
              </p>
              <button
                className={classes.button}
                onClick={() => {
                  handleCardClick(ticket.uuid);
                }}
              >
                {i18n.t("kanban.seeTicket")}
              </button>
            </div>
          ),
          title: ticket.contact.name,
          draggable: true,
          href: "/tickets/" + ticket.uuid,
        })),
      },
      ...tags
            .filter((tag) => (tag.queueId === queue || profile === "admin" && !tag.queueId) )
            .map((tag) => {
                const tagsTickets = tickets.filter((ticket) => {
                    const tagIds = ticket.tags.map((tag) => tag.id);
                    return tagIds.includes(tag.id);
                });
        
                return {
                    id: tag.id.toString(),
                    title: tag.name,
                    label: tagsTickets.length.toString(),
                    cards: tagsTickets.map((ticket) => ({
                        id: ticket.id.toString(),
                        label: "Ticket nº " + ticket.id.toString(),
                        description: (
                        <div>
                            <p>
                            {ticket.contact.number}
                            <br />
                            {ticket.lastMessage}
                            </p>
                            <button
                            className={classes.button}
                            onClick={() => {
                                handleCardClick(ticket.uuid);
                            }}
                            >
                            {i18n.t("kanban.seeTicket")}
                            </button>
                        </div>
                        ),
                        title: ticket.contact.name,
                        draggable: true,
                        href: "/tickets/" + ticket.uuid,
                    })),
                    style: { backgroundColor: tag.color, color: "white" },
                };
            }),
    ];

    setFile({ lanes });
  };

  const handleCardClick = (uuid) => {
    //console.log("Clicked on card with UUID:", uuid);
    history.push("/tickets/" + uuid);
  };

  useEffect(() => {
    popularCards(jsonString);
  }, [tags, tickets]);

  useEffect(() => {
    fetchTickets(jsonString)
  }, [queue]);

  const handleCardMove = async (cardId, sourceLaneId, targetLaneId) => {
    try {
      await api.delete(`/ticket-tags/${targetLaneId}`);
      toast.success(i18n.t("kanban.toasts.removed"));
      await api.put(`/ticket-tags/${targetLaneId}/${sourceLaneId}`);
      toast.success(i18n.t("kanban.toasts.added"));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
        <div className={classes.root}>
            <Grid style={{ width: "99.6%", padding: "1em 0 .5em 1em"}} container>
                <Grid xs={12} sm={8} item>
                    <Title>Kanban</Title>
                </Grid>
                <Grid xs={12} sm={8} item>
                    <FormControl margin="dense" variant="outlined" fullWidth>
                        <InputLabel htmlFor="useOpenAi-selection">{i18n.t("plans.form.queues")}</InputLabel>
                        <Select
                            // as={Select}
                            value={queue}
                            id="queues-selection"
                            label={i18n.t("plans.form.queues")}
                            labelId="queues-selection-label"
                            name="queue"
                            margin="dense"
                            onChange={(e)=>{ setQueue((e.target || e.currentTarget).value); }}
                        >
                            { profile === "admin" ? <MenuItem value={0}>{i18n.t("kanban.notInformed")}</MenuItem> : <></> }
                            {
                                queues.map((q) => (
                                    <MenuItem value={q.id}>{q.name}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>                    
                </Grid>
            </Grid>
        </div>
        <div className={classes.root}>
            <Board
                data={file}
                onCardMoveAcrossLanes={handleCardMove}
                style={{ backgroundColor: "rgba(252, 252, 252, 0.03)" }}
            />
        </div>
    </>
  );
};

export default Kanban;
